// relatedStoriesSlider.ts
import Splide, { Options } from '@splidejs/splide';

export function accessoriesSlider(): void {
    const splideEls = document.querySelectorAll<HTMLElement>('.splide-accessories');

    if (splideEls.length === 0) return;

    splideEls.forEach((el) => {
        const options: Options = {
            gap: '1.5rem',
            pagination: false,
            arrowPath: 'M 25.912216,34.175412 24.328359,32.647051 35.77786,21.197549 H 0 V 18.977707 H 35.820481 L 24.383855,7.5283613 25.912216,6 40,20.087628 Z',
        };

        const splide = new Splide(el, options);

        splide.mount();
    });
}
